import React from 'react'
import TipsView from '../Components/TipsView'
import BankNone from '../Components/BankNone'
import RDCon from '$Deposits/Components/RD'
import SubmitBtn from '../Components/SubmitBtn'
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { bankCodeWriting } from '$Deposits/lib/LibCommonData'
import Modal from "../Components/Modal";
import copy from 'copy-to-clipboard';
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import UserBankSelect from '../Components/UserBankSelect'
import RDTutorialModal from '../Components/RDTutorialModal'
import { connect } from 'react-redux'


class RD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tutorialVisible: false
        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {MethodsDetails} = this.props;
        const { bankAccounts = [] } = MethodsDetails || {}
        const { webPiwikEvent } = GetParamsData()

        return (
            <>
                {!!bankAccounts.length && (
                    <>
                        <div 
                            className='depositTutorialButton' 
                            onClick={() => { 
                                webPiwikEvent("Deposit", "View Tutorial", "Deposit_LBExpress_V_ViewTutorial")
                                this.setState({ tutorialVisible: true }) 
                            }}
                        >
                            <span data-CN="存款流程">ขั้นตอนการฝาก</span>
                        </div>
                        <RDTutorialModal
                            visible={this.state.tutorialVisible}
                            onClose={()=>{this.setState({tutorialVisible:false})}}
                        />
                    </>
                )}
                <div className='methodsActive RD'>
                    <RDCon
                        Modal={(propCon) => {
                            const { modalVisible, msg, onlyOkBtn, onChange, onCancel, } = propCon
                            return <>
                                <Modal
                                    className='modalTips'
                                    visible={modalVisible}
                                    title='ผูกบัญชีไม่สำเร็จ'
                                    okText={onlyOkBtn? 'ปิด': 'ติดต่อฝ่ายบริการ'}
                                    onOk={onlyOkBtn? onCancel: onChange}
                                    cancelText="ปิด"
                                    onCancel={onCancel}
                                    onlyOkBtn={onlyOkBtn}
                                >
                                    <div className='titleIcon'>
                                        <div className={`errorIcon imgIcon`} />
                                    </div>
                                    <p className="intro introCenter">{`${msg}`}</p>
                                </Modal>
                            </>
                        }}
                        BankNone={BankNone}
                        TipsView={TipsView}
                        AddBank={AddBank}
                        BindBank={BindBank}
                        BankActive={BankActive}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodsDetails: state.MethodsDetails,
});
export default connect(mapStateToProps)(RD)

//已绑定
export class BankActive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false
        };
    }

    componentDidUpdate(prevProps, prevState){
        const { webPiwikUrl } = GetParamsData()
        const {modalVisible} = this.state;
        if(prevState.modalVisible !== modalVisible){
            if(modalVisible){
                webPiwikUrl("deposit_rd_changeBank_info_popup", "RD Deposit Page")
            }else{
                webPiwikUrl("deposit_rd", "RD Deposit Page")
            }
        }
    }
    copys = (txt) => {
        try {
            const value = String(txt)
            copy(value)
            const { toastTip } = GetParamsData()
            toastTip.success('คัดลอกแล้ว')

        } catch (error) {

        }
    }

    render() {
        const {
            LivechatClick,
            DepositBankActive,
            setting,
            isShowCS
        } = this.props

        const { webPiwikEvent } = GetParamsData()

        const { modalVisible } = this.state
        return (
            <>
                <Modal
                    className='modalTips'
                    visible={modalVisible}
                    title='เปลี่ยนบัญชีธนาคาร'
                    okText={'ติดต่อฝ่ายบริการ'}
                    onOk={() => { 
                        webPiwikEvent("Deposit", "Contact CS", "Deposit_LBExpress_C_CS")
                        LivechatClick()
                    }}
                    cancelText="ปิด"
                    onCancel={() => { this.setState({modalVisible: false}) }}
                >
                    <div className='RD-maskGroup' />
                    <p className='RD-modal-text'>เรียนสมาชิก หากต้องการเปลี่ยนข้อมูลบัญชี ธนาคารในการโอนเงิน กรุณาติดต่อฝ่ายบริการลูกค้า และส่งเอกสารดังนี้</p>
                    <TipsView style={'RD-modal-tips'} msg={`1.บัตรประชาชน\n2.หน้าสมุดบัญชีธนาคารปัจจุบัน\n3.หน้าสมุดบัญชีธนาคารที่ต้องการเปลี่ยน`} />
                </Modal>
                <div className='addBank'>
                    <TipsView msg={'เนื่องจากบัญชีธนาคารอาจมีการเปลี่ยนแปลง โปรดตรวจสอบบัญชี ธนาคารก่อนการโอนเงินทุกครั้ง'} />
                    <UserBankSelect allowChange={true} step={2} />
                    <div className="tipsMsg blue">
                        {
                            !isShowCS ?  <p className="tipsMsgItem">เพื่อป้องกันยอดเงินสูญหาย โปรดยืนยันบัญชีที่จะใช้ก่อนการโอนเงิน ระบบจะตรวจสอบเฉพาะบัญชีที่เลือกและมีการยืนยันก่อนการโอนทุกครั้ง</p>
                            :
                            <p className="tipsMsgItem">ตรวจสอบให้แน่ใจว่าคุณฝากเงินจากบัญชีธนาคารนี้เท่านั้นป้องกัน ยอดเงินสูญหาย หากต้องการเปลี่ยนธนาคาร <span onClick={()=>{this.setState({modalVisible: true})}}>ตรวจสอบข้อมูลที่นี่</span></p>
                        }

                    </div>
                    <p className="inputTitle">ธนาคาร FUN88</p>
                    <p className='RD-maxBal'>ฝากเงินขั้นต่ำ {numberWithCommas(setting.minBal)} บาทสูงสุด {numberWithCommas(setting.maxBal)} บาทต่อรายการ</p>

                    <div className='bankAccounts'>
                        <div className='RD-icon-name'>
                            <div className={'bankIcon-default-RD bankIcon-' + bankCodeWriting(DepositBankActive.enBankName || '')} />
                            <p className='RD-bank-name'>{DepositBankActive.bankName}</p>
                        </div>
                        <div className='RD-below'>
                            <div className='RD-account-info'>
                                <p className='RD-bank-num'>{DepositBankActive.accountNo}</p>
                                <p className='RD-hold-name'>{DepositBankActive.accountHolderName}</p>
                            </div>
                            <div className='RD-bank-copy' onClick={() => { this.copys(DepositBankActive.accountNo) }}>
                                <span className='copyIcon'></span>
                                <span className='copyIcon-Text'>คัดลอก</span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}


//需要添加
export class AddBank extends React.Component {
    render() {
        const {
            AddBankClick,
        } = this.props

        return (
            <>
                <div className='addBankBox'>
                    <p className='icon' />
                    <p className='title'>เพิ่มบัญชีธนาคาร</p>
                    <p className='addBankItem'>
                        กรุณาเพิ่มบัญชีธนาคารก่อนการฝากเงินแบบฝากด่วนหากเพิ่มแล้วจะไม่สามารถแก้ไข
                        <br />
                        ข้อมูลได้ กรุณาตรวจสอบให้แน่ใจว่าข้อมูลถูกต้อง
                        เพื่อป้องกันธุรกรรมถูกยกเลิก
                        <br />
                        หรือยอดเงินสูญหาย
                    </p>

                    <div className='add-btn' onClick={AddBankClick}>
                        เพิ่มบัญชีธนาคาร
                    </div>
                </div>
            </>
        )
    }
}

//未绑定
export class BindBank extends React.Component {
    render() {
        const {
            LivechatClick,
            onChange,
        } = this.props

        return (
            <div className='rdBindBox'>
                <div>
                    <p className='icon bindBankIcon' />
                    <p className='title'>เลือกบัญชีธนาคาร</p>
                    <p className='addBankItem'>
                        กรุณายืนยันบัญชีธนาคารของคุณสำหรับการฝากเงิน<br/>
                        แบบฝากด่วน หากผูกบัญชีแล้วจะไม่สามารถแก้ไขข้อมูลได้<br/>
                        กรุณาใช้บัญชีที่ผูกในการโอนเงินเท่านั้นป้องกันยอดเงินสูญหาย
                    </p>
                </div>
                <UserBankSelect allowChange={true} step={1} />
                <div className='tipsGray bindTips' onClick={LivechatClick}>
                    หากต้องการเพิ่มบัญชีใหม่ กรุณาติดต่อฝ่ายบริการลูกค้า <span style={{ textDecoration: "underline" }}>ห้องช่วยเหลือสด</span>
                </div>
                <SubmitBtn
                    onPress={() => { onChange() }}
                    submitBtnItem={'ถัดไป'}
                />
            </div>
        )
    }
}


